export default "__VITE_ASSET__DLqatj93__"